import React, { useEffect, useState, useMemo } from "react";
import classes from "../../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get, deleteRecord, put } from "../../../server";
import { FEEDBACK, PRODUCT_DISCOUNT } from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { BsThreeDotsVertical } from "react-icons/bs";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import { useParams } from "react-router-dom";
import { Button, Card, Form, Modal } from "react-bootstrap";
import { FaAngry } from "react-icons/fa";
import { FaGrinHearts } from "react-icons/fa";
import { ImSad2 } from "react-icons/im";
import { FaMeh } from "react-icons/fa";
import { FaSmileBeam } from "react-icons/fa";

const CustomerFeedbackList = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [errors, setErrors] = useState({});
  const [discounts, setDiscounts] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [statusId, setStatusId] = useState(null);
  const [feedbackViewModal, setFeedbackViewModal] = useState(false);
  const [formData, setFormData] = useState([]);
  let { id } = useParams();
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const handleCloseFeedbackModal = () => {
    setFeedbackViewModal(false);
  };

  const loadProductDiscount = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      FEEDBACK,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      // if (data.length > 0) {
      setDiscounts(data);
      const status = data.map((statusValue) => statusValue.status);
      setStatusId(status);
      // }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const filteredItems = useMemo(() => {
    const filtered = discounts.filter(
      (item) =>
        `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.package.package_name || ""}`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        `${item.discount || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, discounts]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Name",
      cell: (row) => (
        <p className="globalDetail">{`${row?.user?.first_name} ${row?.user?.last_name}`}</p>
      ),
    },
    {
      name: "Email",
      cell: (row) => <p className="globalDetail">{row?.user?.email}</p>,
    },
    {
      name: "Date",
      cell: (row) => {
        const creationDate = new Date(row?.created_at);
        const formattedDate = creationDate.toLocaleString();
        return (
          <p className="globalDetail">
            {row?.created_at ? formattedDate : "-"}
          </p>
        );
      },
    },
    {
      name: "Action",
      width: "100px",
      right: "true",
      cell: (row, index) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                onClick={() => {
                  setFeedbackViewModal(true);
                }}
              >
                View
              </Link>
            </li>
            {/* <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li> */}
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (discountId) => {
    setDeleteId(discountId);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${PRODUCT_DISCOUNT}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  const updateStatus = async (discountId) => {
    setLoading(true);
    setStatusId(discountId);
    let newStatus = 1;
    const discountIndex = discounts.findIndex((pkg) => pkg.id === discountId);
    if (discountIndex !== -1) {
      if (statusId[discountIndex] === 1) {
        newStatus = 0;
      }
    }
    const payload = {
      status: newStatus,
    };
    let { status, message } = await put(
      `${PRODUCT_DISCOUNT}/${discountId}/update/status`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadProductDiscount();
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadProductDiscount();
  }, []);

  return (
    <>
      {!loading ? (
        <div>
          <div className="heading">
            <h1 className="pageTitle">
              Customer Feedback <span>({discounts.length})</span>
            </h1>
          </div>
          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="coupon"
          />
          <Modal
            size="lg"
            show={feedbackViewModal}
            onHide={handleCloseFeedbackModal}
            aria-labelledby="contained-modal-title-vcenter"
            // className="customModal"
          >
            <Modal.Body
              className={`d-flex justify-content-center flex-column align-items-center`}
            >
              <div className="public-coupon-page">
                <div className="container">
                  <div className="row justify-content-center align-items-center">
                    <div className="col-12">
                      <Card>
                        <Card.Body>
                          {/* <h1 className="mb-2">Feedback Request Form</h1>
                          <small>
                            We would love to hear your thoughts on ContactCo!
                            Please take a moment to fill out this feedback form
                            to help us improve our services.
                          </small> */}
                          <Form className="feedback-form">
                            {discounts?.map((item, index) =>
                              item?.feedbacks?.map((qus, index) => (
                                <div className="form-group mb-2" key={index}>
                                  <label className="form-label">
                                    {qus?.question}
                                  </label>
                                  {qus?.question_id === 1 ? (
                                    <div className="feedback-satisfied">
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${item.id}`}
                                          value={1}
                                          checked={
                                            parseInt(qus?.answers?.answer) === 1
                                          }
                                          readOnly
                                        />
                                        <label class="form-check-label">
                                          <FaAngry />
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${qus.question_id}`}
                                          value={2}
                                        />
                                        <label class="form-check-label">
                                          <ImSad2 />
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${qus.question_id}`}
                                          value={3}
                                        />
                                        <label class="form-check-label">
                                          <FaMeh />
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${qus.question_id}`}
                                          value={4}
                                          checked={
                                            parseInt(qus?.answers?.answer) === 4
                                          }
                                          readOnly
                                        />
                                        <label class="form-check-label">
                                          <FaSmileBeam />
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${qus.question_id}`}
                                          value={5}
                                        />
                                        <label class="form-check-label">
                                          <FaGrinHearts />
                                        </label>
                                      </div>
                                    </div>
                                  ) : qus?.question_id === 2 ? (
                                    <div className="row">
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Digital Card"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Digital Card
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Payment"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Payment Service
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Emergency Contacts"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Emergency Contacts
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Custom URL"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Custom URL’s
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "File Upload"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            File Upload
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Lead Builder"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Lead Builder
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Memory"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Memory
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 col-lg-4">
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            checked={qus?.answers?.answer?.includes(
                                              "Medical ID"
                                            )}
                                            readOnly
                                          />
                                          <label class="form-check-label">
                                            Medical ID
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  ) : qus?.question_id === 3 ? (
                                    <input
                                      className="form-control mb-3"
                                      value={qus?.answers?.answer}
                                      readOnly
                                    />
                                  ) : qus?.question_id === 4 ? (
                                    <input
                                      className="form-control mb-3"
                                      value={qus?.answers?.answer}
                                      readOnly
                                    />
                                  ) : qus?.question_id === 5 ? (
                                    <div className="feedback-often">
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${item.id}`}
                                          value="Daily"
                                          checked={
                                            qus?.answers?.answer === "Daily"
                                              ? true
                                              : false
                                          }
                                          readOnly
                                        />
                                        <label class="form-check-label">
                                          Daily
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${item.id}`}
                                          value="Weekly"
                                          checked={
                                            qus?.answers?.answer === "Weekly"
                                              ? true
                                              : false
                                          }
                                          readOnly
                                        />
                                        <label class="form-check-label">
                                          Weekly
                                        </label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name={`question_${item.id}`}
                                          value="Occasionally"
                                          checked={
                                            qus?.answers?.answer ===
                                            "Occasionally"
                                              ? true
                                              : false
                                          }
                                          readOnly
                                        />
                                        <label class="form-check-label">
                                          Occasionally
                                        </label>
                                      </div>
                                    </div>
                                  ) : qus?.question_id === 6 ? (
                                    <div className="feedback-recommend">
                                      {[...Array(10)].map((_, i) => {
                                        const value = i + 1;
                                        return (
                                          <div
                                            className="form-check form-check-inline"
                                            key={value}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="radio"
                                              name={`question_${item.id}_${qus.question_id}`}
                                              value={value}
                                              checked={
                                                parseInt(
                                                  qus?.answers?.answer
                                                ) === value
                                              }
                                              readOnly
                                            />
                                            <label className="form-check-label">
                                              {value}
                                            </label>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ) : qus?.question_id === 7 ? (
                                    <textarea
                                      className="form-control"
                                      value={qus?.answers?.answer}
                                      readOnly
                                    ></textarea>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            )}
                          </Form>
                          <div className="text-end">
                            <Button
                              variant="outline-primary"
                              className="mt-4"
                              onClick={handleCloseFeedbackModal}
                            >
                              Close
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default CustomerFeedbackList;
